import { profile as en_profile } from "../en/profile";

/** profile — RU slice (39 keys). */
export const profile: Record<keyof typeof en_profile, string> = {
  profile_info_interests_label: "Интересы",
  profile_info_about_label: "О себе",
  profile_info_photos_label: "Фото",
  profile_info_distance_mi: "{miles} миль",
  profile_info_distance_mi_nearby: "рядом",
  profile_info_full_name_age: "{name}, {age}",
  profile_edit_gender_label: "Пол",
  profile_edit_about_label: "О себе",
  profile_edit_first_name_label: "Имя",
  profile_edit_last_name_label: "Фамилия",
  profile_edit_first_name_placeholder: "Введи своё имя",
  profile_edit_last_name_placeholder: "Введи свою фамилию",
  profile_edit_about_placeholder: "живи, смейся, люби — согласен?",
  profile_edit_gender_text_none: "Предпочитаю не указывать",
  profile_edit_gender_text_male: "Мужчина",
  profile_edit_gender_text_female: "Женщина",
  profile_edit_birthdate_label: "Дата рождения",
  profile_edit_birthdate_placeholder_day: "День",
  profile_edit_birthdate_placeholder_month: "Месяц",
  profile_edit_birthdate_placeholder_year: "Год",
  profile_filter_gender_label: "Кого хочешь встретить",
  profile_filter_age_label: "Возраст",
  profile_filter_age_min_label: "От",
  profile_filter_age_max_label: "До",
  profile_filter_distance_label: "Расстояние",
  profile_filter_distance_label_value: "{radius} миль",
  profile_filter_gender_value_text_none: "Все",
  profile_filter_gender_value_text_male: "Мужчина",
  profile_filter_gender_value_text_female: "Женщина",
  profile_menu_edit_title: "Редактировать профиль",
  profile_menu_edit_subtitle: "Обнови основную информацию и описание",
  profile_menu_filters_title: "Фильтры",
  profile_menu_filters_subtitle: "Настрой, кого хочешь встречать",
  profile_menu_photos_title: "Фото",
  profile_menu_photos_subtitle: "Управляй галереей и меняй порядок",
  profile_menu_interests_title: "Интересы",
  profile_menu_interests_subtitle: "Покажи, что тебе важно",
  profile_menu_settings_title: "Настройки",
  profile_menu_settings_subtitle: "Управляй аккаунтом и предпочтениями",
};
